// Open-redirect guard: allow only same-origin paths; null for external, protocol-relative, or malformed values.
export const sanitizeRedirect = (raw?: string | null): string | null => {
  if (!raw) return null;
  let url: URL;
  try {
    url = new URL(raw, window.location.origin);
  } catch {
    return null;
  }
  return url.origin === window.location.origin
    ? url.pathname + url.search + url.hash
    : null;
};
